/**
 * Input Group Component
 * Responsible for showing input level errors specific to a particular field
 *
 */
import { Component, ElementRef, inject, input } from '@angular/core';
import { InteractivityService } from '../../../services/interactivity-service';

export type LabelPosition = 'left' | 'top'

@Component({
  selector: 'td-wb-input-group',
  templateUrl: 'input-group.component.html',
  styleUrls: ['input-group.component.scss'],
  host: {
    '[class.td-wb-input-group--label-top]': 'labelPosition() === "top"'
  }
})
export class InputGroupComponent {
  readonly labelPosition = input<LabelPosition>('top');
  private readonly elementRef = inject(ElementRef);
  private readonly interactivityService = inject(InteractivityService);

  focusInput(): void {
    const elementRef = this.interactivityService.getFirstTabbableElement(this.elementRef.nativeElement);
    if (elementRef && typeof elementRef.focus === 'function') {
      elementRef.focus();
    }
  }
}
